import Button from "components/atoms/Button/Button";
import errorToast from "helpers/errorToast";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { updateInvoice } from "api";
import CardNew from "components/molecules/Card/CardNew";

function DebitReference({ invoice, isLoading }) {
  const methods = useForm();
  const { handleSubmit, getValues, setValue, register } = methods;
  const intl = useIntl();

  const [isSaveInProgress, setIsSaveInProgress] = useState(false);
  const [auditOptions, setAuditOptions] = useState({});
  const [hasValueChanged, setHasValueChanged] = useState(false);

  useEffect(() => {
    const auditOptions = invoice?.audit_options;
    const shipperInvoiceRef01 = invoice?.invoice_references?.shipper_invoice_ref1;
    if (auditOptions && auditOptions.shipper_invoice_ref1_enabled) {
      if (shipperInvoiceRef01) setValue(`shipperInvoiceReference`, shipperInvoiceRef01);
    }
    setAuditOptions(auditOptions);
  }, [invoice]);

  const handleSave = () => {
    setIsSaveInProgress(true);
    const invoiceId = invoice?.invoice_id;
    const payload = {
      shipper_invoice_ref1: getValues("shipperInvoiceReference"),
    };
    if (invoiceId) {
      updateInvoice(invoiceId, payload)
        .then((res) => {
          if (res.status === 200) {
            toast(
              intl.formatMessage({
                id: "general.submittedSuccessfully",
                defaultMessage: "Submitted successfully",
              }),
              { type: "success" },
            );
          }
        })
        .catch((error) => errorToast(error))
        .finally(() => {
          setIsSaveInProgress(false);
          setHasValueChanged(false);
        });
    }
  };

  if (!auditOptions?.shipper_invoice_ref1_enabled && !auditOptions?.can_be_audited) return null;
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleSave)}>
        <CardNew
          className="mb-15"
          title={intl.formatMessage({
            id: "billing.debitReference",
            defaultMessage: "Debit Reference",
          })}
          isLoading={isLoading}
        >
          <input
            {...register("shipperInvoiceReference")}
            type="text"
            required
            className="rounded-input"
            onChange={() => {
              setHasValueChanged(true);
            }}
          />
          {hasValueChanged && (
            <Button
              className="rounded-pill ml-auto font-12 mt-2"
              style={{ padding: "6px 16px" }}
              label={
                isSaveInProgress ? (
                  <FontAwesomeIcon icon={faCircleNotch} className="font-16" spin />
                ) : (
                  intl.formatMessage({
                    id: "general.save",
                    defaultMessage: "Save",
                  })
                )
              }
              variant="primary"
              type="submit"
            />
          )}
        </CardNew>
      </form>
    </FormProvider>
  );
}

DebitReference.propTypes = {
  invoice: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default DebitReference;
